// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import {
  loadingHide,
  loadingShow,
} from 'redux/modules/loading'

// NOTE - This is the hook equivalent of the loadingToggler thunk
// (See redux/modules/loading/loadingToggler.js)

// the only difference is in the fact that we do not await
// loadingShow/loadingHide and this is so that we can more easily
// test custom hooks which use this since it will often be called within
// a useEffect, the timing of which we have very little control over.
// in actual use, it doesn't matter if we await these or not.
// I think it was just something I chose to do in the thunk to enforce
// the order of firing on the redux store.

// But as long as we don't care about the global isLoading value
// from within this hook we're totally fine. (which like that shouldn't
// ever be a thing even in the thunk because this is just a UI feature
// and should have no importance on business logic.)

const useLoadingToggler = () => {
  const dispatch = useDispatch()

  return useCallback(async operationToRun => {
    dispatch(loadingShow())

    try {
      const res = await operationToRun()
      await dispatch(loadingHide())
      return res
    } catch (err) {
      // if the async operation throws an error,
      // be sure to close the loading icon before throwing the error to the caller
      await dispatch(loadingHide())
      throw err
    }
  }, [])
}

export default useLoadingToggler
